var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Lists',{attrs:{"liebiaos":_vm.liebiaos,"totlePage":_vm.totlePage,"isLiuyan":true},on:{"liebiao2":_vm.liebiao2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }